import React, { useState } from "react";
import styled from "styled-components";
import ReactApexChart from "react-apexcharts";
import { NumberColumns } from "./NumberColumns";

export const ColumnColumnClients = () => {
  const [selectedFilter, setSelectedFilter] = useState("mes");

  const monthlyData = {
    series: [
      {
        name: "Usuarios",
        data: [70, 50, 65, 60, 70, 73],
      },
    ],
    options: {
      chart: {
        type: "line",
        height: 350,
        toolbar: {
          show: false,
        },
      },
      xaxis: {
        categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
      },
      stroke: {
        curve: "smooth",
      },
      markers: {
        size: 5,
      },
    },
  };

  const weeklyData = {
    series: [
      {
        name: "Usuarios",
        data: [12, 8, 6, 7, 9, 11, 10],
      },
    ],
    options: {
      chart: {
        type: "line",
        height: 350,
        toolbar: {
          show: false,
        },
      },
      xaxis: {
        categories: ["Lun", "Mar", "Mie", "Jue", "Vie", "Sab", "Dom"],
      },
      stroke: {
        curve: "smooth",
      },
      markers: {
        size: 5,
      },
    },
  };

  const handleFilterChange = (filter) => {
    setSelectedFilter(filter);
  };

  const data = selectedFilter === "semana" ? weeklyData : monthlyData;

  return (
    <MainContainer>
      <ChartColumnCard>
        <HeaderContainer>
          <ChartTitle>Clientes</ChartTitle>
          <ButtonContainer>
            <FilterButton selected={selectedFilter === "semana"} onClick={() => handleFilterChange("semana")}>
              Semana
            </FilterButton>
            <FilterButton selected={selectedFilter === "mes"} onClick={() => handleFilterChange("mes")}>
              Mes
            </FilterButton>
          </ButtonContainer>
        </HeaderContainer>
        <ContainerCharts>
          <ReactApexChart options={data.options} series={data.series} type="line" height="100%" width="100%" />
        </ContainerCharts>
      </ChartColumnCard>
      <NumberColumnsContainer>
        <NumberColumns selectedFilter={selectedFilter} />
      </NumberColumnsContainer>
    </MainContainer>
  );
};

const MainContainer = styled.div`
  display: flex;
  width: 74%;
  height: 60vh;
  background-color: #c0c0c0;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 30px;
`;

const ChartColumnCard = styled.div`
  display: flex;
  flex-direction: column;
  width: 80%;
  height: 100%;
  background-color: #ffffff;
  border-radius: 10px;
  margin-right: 20px;
  overflow: hidden;
`;

const ContainerCharts = styled.div`
  display: flex;
  flex-direction: column;
  margin: 10px;
  height: calc(100% - 40px);
`;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 15px;
`;

const ChartTitle = styled.h2`
  font-size: 1.2em;
  color: #333;
  text-align: left;
  font-family: "Roboto", sans-serif;
`;

const NumberColumnsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 20%;
  height: 90%;
  background-color: #ffffff;
  border-radius: 10px;
  padding: 20px;
`;

const ButtonContainer = styled.div`
  display: flex;
`;

const FilterButton = styled.button`
  background-color: ${({ selected }) => (selected ? "#f00" : "#fff")};
  color: ${({ selected }) => (selected ? "#fff" : "#000")};
  border: 2px solid #f00;
  border-radius: 5px;
  padding: 5px 10px;
  margin-right: 10px;
  cursor: pointer;
  font-family: "Roboto", sans-serif;
  font-size: 0.9em;
  &:focus {
    outline: none;
  }
  &:hover {
    background-color: ${({ selected }) => (selected ? "#d00" : "#f5f5f5")};
  }
`;
